import api from 'api'

export const updateField = async (stepId, id, payload) => {
  const { data } = await api.put(`/step/${stepId}/field/${id}`, payload)

  return data
}
